/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAISessionFromJSON, ApiAISessionToJSON, } from './ApiAISession';
export function ApiCreateSessionResponseFromJSON(json) {
    return ApiCreateSessionResponseFromJSONTyped(json, false);
}
export function ApiCreateSessionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'session': !exists(json, 'session') ? undefined : ApiAISessionFromJSON(json['session']),
    };
}
export function ApiCreateSessionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'session': ApiAISessionToJSON(value.session),
    };
}
